var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88846 7.12857H5.04449M6.17924 8.5H1.75371C1.50302 8.5 1.2998 8.29533 1.2998 8.04286V6.82166C1.2998 6.72407 1.33081 6.62905 1.38829 6.55048L2.69006 4.77118C2.80804 4.60992 2.80804 4.39008 2.69006 4.22882L1.38829 2.44952C1.33081 2.37095 1.2998 2.27593 1.2998 2.17834V0.957143C1.2998 0.70467 1.50302 0.5 1.75371 0.5H6.06576C6.31644 0.5 6.51966 0.70467 6.51966 0.957143V2.18715C6.51966 2.27928 6.49202 2.36926 6.44037 2.44529L5.22652 4.23205C5.11751 4.39251 5.1212 4.60485 5.23571 4.76137L6.54465 6.55048C6.60213 6.62905 6.63314 6.72407 6.63314 6.82166V8.04286C6.63314 8.29533 6.42992 8.5 6.17924 8.5Z",
    stroke: "#3E82FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass-icon.fe63422add14fdaa1224f2737105542c.svg";
export { ForwardRef as ReactComponent };